<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Ship" subTitle="Forms" />

    <ListVessel />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListVessel from "@/components/Pages/Master/Vessel/ListVessel.vue";

export default defineComponent({
  name: "ListVesselPage",
  components: {
    PageTitle,
    ListVessel,
  },
});
</script>
